import { render, staticRenderFns } from "./edit-ceping-group.vue?vue&type=template&id=4cdec216&scoped=true"
import script from "./edit-ceping-group.vue?vue&type=script&lang=ts"
export * from "./edit-ceping-group.vue?vue&type=script&lang=ts"
import style0 from "./edit-ceping-group.vue?vue&type=style&index=0&id=4cdec216&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdec216",
  null
  
)

export default component.exports